import { ITooltipSetting } from 'redhotpie-shared-lib/interfaces/IUser';

export default class ToolTipSetting {
  id: number;
  name: string;
  display: boolean;
  ViewCount: number;

  constructor() {
    this.id = -1;
    this.name = '';
    this.display = true;
    this.ViewCount = 0;
  }

  static mappingObject(_toolTip: any): ITooltipSetting {
    const toolTip = Object.assign(new ToolTipSetting(), _toolTip);
    toolTip.id = _toolTip.ToolTipType.ID;
    toolTip.name = _toolTip.ToolTipType.Name;
    toolTip.display = _toolTip.ViewCount < _toolTip.ToolTipType.DisplayLimit;
    toolTip.ViewCount = _toolTip.ViewCount;
    // ToolTip.display = true;
    return toolTip;
  }

  static mappingObjects(_toolTips: any): ITooltipSetting[] {
    const toolTips: ToolTipSetting[] = [];
    _toolTips.forEach((_toolTip: any) => {
      const toolTip = ToolTipSetting.mappingObject(_toolTip);
      toolTips.push(toolTip);
    });
    return toolTips;
  }
}
